import axios from "axios";

export const privateApiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});

export const publicApiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});
